import { getMapThumbnailLink } from 'utils'
import fetch from 'map-data-fetch'
import { genCoverageData } from 'data-utils/geojson/metadata-enrichment/generate-coverage-object'

export interface MapSchema {
  '@context': 'http://schema.org'
  '@type': 'Map'
  name: string
  image: string
  about: {
    '@type': 'Place'
    name: string
    description: string
    containedInPlace: {
      '@type': string
      name: string
    }
  }
  author: {
    '@type': 'Organization'
    name: string
  }
  publisher: {
    '@type': 'Organization'
    name: string
    logo: {
      '@type': 'ImageObject'
      url: string
    }
  }
  datePublished?: string
  dateModified?: string
  inLanguage: string
  mainEntity: {
    '@type': 'WebPage'
    '@id': string
  }
}

export const getMapSchema = async (
  map,
  router,
  baseUrl
): Promise<MapSchema> => {
  const mapName = map?.name

  const geojson = await fetch(`public/${map.dataId}`, 'geojson')
  const coverageData = await genCoverageData(geojson.features)

  return {
    '@context': 'http://schema.org',
    '@type': 'Map',
    name: mapName,
    image: getMapThumbnailLink(map) || '',
    about: {
      '@type': 'Place',
      name: mapName,
      description: `${mapName} | Interactive map.`,
      containedInPlace: {
        '@type': coverageData.type,
        name: coverageData.name
      }
    },
    author: {
      '@type': 'Organization',
      name: 'Mapstack'
    },
    publisher: {
      '@type': 'Organization',
      name: 'Mapstack',
      logo: {
        '@type': 'ImageObject',
        url: `${baseUrl}/icons/mapstack-logo.png`
      }
    },
    datePublished: map?.createdAt,
    dateModified: map?.updatedAt,
    inLanguage: 'en',
    mainEntity: {
      '@type': 'WebPage',
      '@id': router.asPath
    }
  }
}
